import { Question } from './types';
import { OptionItem } from '../components/QuestionOptionInput';

// Generate a set of questions for each standard
export const mockQuestions: Question[] = [
  // Questions for standard-001 (K.CC.A.1) - Count to 100 by ones and by tens - EASY
  {
    id: 'question-001',
    standardId: 'standard-001',
    text: 'Count by ones. What number comes after 5?',
    type: 'MultipleChoice',
    difficulty: 'Easy',
    options: [
      { text: '4', image: undefined },
      { text: '5', image: undefined },
      { text: '6', image: undefined },
      { text: '7', image: undefined }
    ],
    correctAnswer: '6',
    hints: ['Think about counting 1, 2, 3, 4, 5, ...']
  },
  {
    id: 'question-002',
    standardId: 'standard-001',
    text: 'Count by tens. What number comes after 30?',
    type: 'MultipleChoice',
    difficulty: 'Easy',
    options: [
      { text: '20', image: undefined },
      { text: '30', image: undefined },
      { text: '40', image: undefined },
      { text: '50', image: undefined }
    ],
    correctAnswer: '40',
    hints: ['Think about counting 10, 20, 30, ...']
  },
  {
    id: 'question-A001',
    standardId: 'standard-001',
    text: 'Count by ones. What number comes after 18?',
    type: 'MultipleChoice',
    difficulty: 'Easy',
    options: [
      { text: '17', image: undefined },
      { text: '19', image: undefined },
      { text: '20', image: undefined },
      { text: '21', image: undefined }
    ],
    correctAnswer: '19',
    hints: ['Count up one from 18']
  },
  {
    id: 'question-A002',
    standardId: 'standard-001',
    text: 'Count by tens. What number comes after 70?',
    type: 'MultipleChoice',
    difficulty: 'Easy',
    options: [
      { text: '60', image: undefined },
      { text: '70', image: undefined },
      { text: '80', image: undefined },
      { text: '90', image: undefined }
    ],
    correctAnswer: '80',
    hints: ['Think about counting 50, 60, 70, ...']
  },
  {
    id: 'question-A003',
    standardId: 'standard-001',
    text: 'Fill in the missing number: 7, 8, ___, 10',
    type: 'TypeIn',
    difficulty: 'Easy',
    correctAnswer: '9',
    hints: ['Count one by one from 7']
  },
  
  // Questions for standard-001 (K.CC.A.1) - Count to 100 by ones and by tens - MEDIUM
  {
    id: 'question-003',
    standardId: 'standard-001',
    text: 'Fill in the missing number: 45, 46, 47, ___, 49',
    type: 'TypeIn',
    difficulty: 'Medium',
    correctAnswer: '48',
    hints: ['Count one by one starting from 45']
  },
  {
    id: 'question-A004',
    standardId: 'standard-001',
    text: 'What is the next number when counting by tens: 10, 20, 30, 40, 50, ___?',
    type: 'MultipleChoice',
    difficulty: 'Medium',
    options: [
      { text: '55', image: undefined },
      { text: '60', image: undefined },
      { text: '65', image: undefined },
      { text: '70', image: undefined }
    ],
    correctAnswer: '60',
    hints: ['Continue the pattern of adding 10 each time']
  },
  {
    id: 'question-A005',
    standardId: 'standard-001',
    text: 'Count by tens starting at 5: 5, 15, 25, ___',
    type: 'TypeIn',
    difficulty: 'Medium',
    correctAnswer: '35',
    hints: ['Add 10 to 25']
  },
  {
    id: 'question-A006',
    standardId: 'standard-001',
    text: 'Fill in the missing numbers: 52, 53, ___, ___, 56',
    type: 'TypeIn',
    difficulty: 'Medium',
    correctAnswer: '54, 55',
    hints: ['Count one by one from 52']
  },
  {
    id: 'question-A007',
    standardId: 'standard-001',
    text: 'Count backwards from 20. What number comes before 18?',
    type: 'MultipleChoice',
    difficulty: 'Medium',
    options: [
      { text: '19', image: undefined },
      { text: '17', image: undefined },
      { text: '16', image: undefined },
      { text: '15', image: undefined }
    ],
    correctAnswer: '19',
    hints: ['When counting backwards, we go 20, 19, 18...']
  },
  
  // Questions for standard-001 (K.CC.A.1) - Count to 100 by ones and by tens - HARD
  {
    id: 'question-A008',
    standardId: 'standard-001',
    text: 'Fill in the missing numbers in this counting sequence: 45, ___, 55, ___, 65, 75',
    type: 'TypeIn',
    difficulty: 'Hard',
    correctAnswer: '55, 65',
    hints: ['Look at the pattern of numbers']
  },
  {
    id: 'question-A009',
    standardId: 'standard-001',
    text: 'Count by tens starting from 3: What is the 8th number in this sequence?',
    type: 'MultipleChoice',
    difficulty: 'Hard',
    options: [
      { text: '73', image: undefined },
      { text: '83', image: undefined },
      { text: '80', image: undefined },
      { text: '33', image: undefined }
    ],
    correctAnswer: '73',
    hints: ['The sequence starts with 3, then 13, 23, etc.']
  },
  {
    id: 'question-A010',
    standardId: 'standard-001',
    text: 'Fill in the missing numbers: 87, 88, ___, ___, 91, 92',
    type: 'TypeIn',
    difficulty: 'Hard',
    correctAnswer: '89, 90',
    hints: ['Count one by one from 87']
  },
  {
    id: 'question-A011',
    standardId: 'standard-001',
    text: 'What comes next? 2, 12, 22, 32, ___?',
    type: 'MultipleChoice',
    difficulty: 'Hard',
    options: [
      { text: '40', image: undefined },
      { text: '42', image: undefined },
      { text: '33', image: undefined },
      { text: '43', image: undefined }
    ],
    correctAnswer: '42',
    hints: ['The pattern is adding 10 each time']
  },
  {
    id: 'question-A012',
    standardId: 'standard-001',
    text: 'Count by 10s from 5 to 95. How many numbers will you say?',
    type: 'TypeIn',
    difficulty: 'Hard',
    correctAnswer: '10',
    hints: ['The sequence is 5, 15, 25, 35, 45, 55, 65, 75, 85, 95']
  },
  
  // Questions for standard-002 (K.CC.A.2) - Count forward beginning from a given number
  {
    id: 'question-004',
    standardId: 'standard-002',
    text: 'Start counting at 7. What is the next number?',
    type: 'MultipleChoice',
    difficulty: 'Easy',
    options: [
      { text: '6', image: undefined },
      { text: '7', image: undefined },
      { text: '8', image: undefined },
      { text: '9', image: undefined }
    ],
    correctAnswer: '8',
    hints: ['When you count forward from 7, you say 7, and then...']
  },
  {
    id: 'question-005',
    standardId: 'standard-002',
    text: 'Start counting at 15. What are the next three numbers?',
    type: 'MultipleChoice',
    difficulty: 'Medium',
    options: [
      { text: '16, 17, 18', image: undefined },
      { text: '14, 13, 12', image: undefined },
      { text: '16, 18, 20', image: undefined },
      { text: '15, 16, 17', image: undefined }
    ],
    correctAnswer: '16, 17, 18',
    hints: ['Count forward one by one starting from 15']
  },
  {
    id: 'question-006',
    standardId: 'standard-002',
    text: 'Fill in the blanks: 23, ___, ___, 26',
    type: 'TypeIn',
    difficulty: 'Medium',
    correctAnswer: '24, 25',
    hints: ['Count forward one by one starting from 23']
  },
  
  // Questions for standard-003 (K.CC.A.3) - Write numbers 0-20
  {
    id: 'question-007',
    standardId: 'standard-003',
    text: 'Which of these shows the number fifteen written as a numeral?',
    type: 'MultipleChoice',
    difficulty: 'Easy',
    options: [
      { text: '51', image: undefined },
      { text: '15', image: undefined },
      { text: '5', image: undefined },
      { text: '50', image: undefined }
    ],
    correctAnswer: '15',
    hints: ['A numeral is a symbol that represents a number, like "5" or "10"']
  },
  {
    id: 'question-008',
    standardId: 'standard-003',
    text: 'Write the number 12 as a numeral.',
    type: 'TypeIn',
    difficulty: 'Easy',
    correctAnswer: '12',
    hints: ['Twelve is written with two digits']
  },
  {
    id: 'question-009',
    standardId: 'standard-003',
    text: 'Match each number word to its numeral.',
    type: 'DragAndDrop',
    difficulty: 'Medium',
    options: [
      { text: 'seventeen:17', image: undefined },
      { text: 'thirteen:13', image: undefined },
      { text: 'twenty:20', image: undefined },
      { text: 'nine:9', image: undefined }
    ],
    correctAnswer: '17,13,20,9',
    hints: ['Remember that "teen" numbers are 13 through 19']
  },
  
  // Questions for standard-004 (1.OA.A.1) - Addition and subtraction word problems
  {
    id: 'question-010',
    standardId: 'standard-004',
    text: 'Sara had 5 apples. Then she got 3 more apples. How many apples does Sara have now?',
    type: 'MultipleChoice',
    difficulty: 'Easy',
    options: [
      { text: '2', image: undefined },
      { text: '8', image: undefined },
      { text: '15', image: undefined },
      { text: '5', image: undefined }
    ],
    correctAnswer: '8',
    hints: ['You need to add the numbers']
  },
  {
    id: 'question-011',
    standardId: 'standard-004',
    text: 'Tom had 9 toy cars. He gave 4 cars to his friend. How many toy cars does Tom have now?',
    type: 'MultipleChoice',
    difficulty: 'Medium',
    options: [
      { text: '5', image: undefined },
      { text: '13', image: undefined },
      { text: '4', image: undefined },
      { text: '6', image: undefined }
    ],
    correctAnswer: '5',
    hints: ['You need to subtract the number of cars he gave away']
  },
  {
    id: 'question-012',
    standardId: 'standard-004',
    text: 'Maria had some stickers. She got 6 more stickers and now has 14 stickers. How many stickers did Maria have at first?',
    type: 'TypeIn',
    difficulty: 'Hard',
    correctAnswer: '8',
    hints: ['If adding 6 gives her 14 total, what number plus 6 equals 14?']
  },
  
  // Questions for standard-005 (1.OA.A.2) - Addition of three whole numbers
  {
    id: 'question-013',
    standardId: 'standard-005',
    text: 'What is 3 + 2 + 4?',
    type: 'MultipleChoice',
    difficulty: 'Easy',
    options: [
      { text: '7', image: undefined },
      { text: '9', image: undefined },
      { text: '6', image: undefined },
      { text: '12', image: undefined }
    ],
    correctAnswer: '9',
    hints: ['Add the numbers one at a time from left to right']
  },
  {
    id: 'question-014',
    standardId: 'standard-005',
    text: 'Lucy picked 3 red apples, 5 green apples, and 2 yellow apples. How many apples did she pick in all?',
    type: 'TypeIn',
    difficulty: 'Medium',
    correctAnswer: '10',
    hints: ['Add all three numbers together']
  },
  {
    id: 'question-015',
    standardId: 'standard-005',
    text: 'Find the total: 7 + 8 + 5',
    type: 'MultipleChoice',
    difficulty: 'Hard',
    options: [
      { text: '18', image: undefined },
      { text: '20', image: undefined },
      { text: '15', image: undefined },
      { text: '25', image: undefined }
    ],
    correctAnswer: '20',
    hints: ['Try adding 7 + 8 first, then add 5']
  },
  
  // Questions for higher grade standards
  
  // Questions for standard-010 (4.NF.A.1) - Equivalent fractions
  {
    id: 'question-016',
    standardId: 'standard-010',
    text: 'Which fraction is equivalent to 1/2?',
    type: 'MultipleChoice',
    difficulty: 'Easy',
    options: [
      { text: '2/4', image: undefined },
      { text: '1/4', image: undefined },
      { text: '2/3', image: undefined },
      { text: '3/4', image: undefined }
    ],
    correctAnswer: '2/4',
    hints: ['Multiply both the numerator and denominator by the same number']
  },
  {
    id: 'question-017',
    standardId: 'standard-010',
    text: 'Find a fraction equivalent to 3/4.',
    type: 'TypeIn',
    difficulty: 'Medium',
    correctAnswer: '6/8',
    hints: ['You can multiply the numerator and denominator by 2 to find an equivalent fraction']
  },
  {
    id: 'question-018',
    standardId: 'standard-010',
    text: 'Match each fraction with its equivalent form.',
    type: 'DragAndDrop',
    difficulty: 'Hard',
    options: [
      { text: '1/3:2/6', image: undefined },
      { text: '2/5:4/10', image: undefined },
      { text: '3/4:6/8', image: undefined },
      { text: '1/2:3/6', image: undefined }
    ],
    correctAnswer: '2/6,4/10,6/8,3/6',
    hints: ['Check if the ratios are the same between each pair']
  },
  
  // Questions for standard-012 (5.NBT.A.1) - EASY
  {
    id: 'question-019',
    standardId: 'standard-012',
    text: 'In the number 3,745, what is the value of the digit 7?',
    type: 'MultipleChoice',
    difficulty: 'Easy',
    options: [
      { text: '7', image: undefined },
      { text: '70', image: undefined },
      { text: '700', image: undefined },
      { text: '7,000', image: undefined }
    ],
    correctAnswer: '700',
    hints: ['Look at the place value of the digit 7']
  },
  {
    id: 'question-B001',
    standardId: 'standard-012',
    text: 'In the number 5,289, what is the value of the digit 8?',
    type: 'MultipleChoice',
    difficulty: 'Easy',
    options: [
      { text: '8', image: undefined },
      { text: '80', image: undefined },
      { text: '800', image: undefined },
      { text: '8,000', image: undefined }
    ],
    correctAnswer: '80',
    hints: ['Look at the place value of the digit 8']
  },
  {
    id: 'question-B002',
    standardId: 'standard-012',
    text: 'What is the value of the digit 4 in the number 2,467?',
    type: 'MultipleChoice',
    difficulty: 'Easy',
    options: [
      { text: '4', image: undefined },
      { text: '40', image: undefined },
      { text: '400', image: undefined },
      { text: '4,000', image: undefined }
    ],
    correctAnswer: '400',
    hints: ['Consider the place value position of 4']
  },
  {
    id: 'question-B003',
    standardId: 'standard-012',
    text: 'In the number 9,302, what is the value of the digit 3?',
    type: 'MultipleChoice',
    difficulty: 'Easy',
    options: [
      { text: '3', image: undefined },
      { text: '30', image: undefined },
      { text: '300', image: undefined },
      { text: '3,000', image: undefined }
    ],
    correctAnswer: '300',
    hints: ['Look at where the 3 is positioned']
  },
  {
    id: 'question-B004',
    standardId: 'standard-012',
    text: 'What is the value of the digit 6 in 8,654?',
    type: 'MultipleChoice',
    difficulty: 'Easy',
    options: [
      { text: '6', image: undefined },
      { text: '60', image: undefined },
      { text: '600', image: undefined },
      { text: '6,000', image: undefined }
    ],
    correctAnswer: '600',
    hints: ['Think about the position of 6 in the number']
  },
  
  // Questions for standard-012 (5.NBT.A.1) - MEDIUM
  {
    id: 'question-B005',
    standardId: 'standard-012',
    text: 'In 45,678, how many times greater is the value of 5 than the value of 8?',
    type: 'MultipleChoice',
    difficulty: 'Medium',
    options: [
      { text: '100', image: undefined },
      { text: '10', image: undefined },
      { text: '1,000', image: undefined },
      { text: '3', image: undefined }
    ],
    correctAnswer: '1,000',
    hints: ['Compare the place values of 5 and 8']
  },
  {
    id: 'question-B006',
    standardId: 'standard-012',
    text: 'In 3,456, the digit 5 is how many times the value of the digit 6?',
    type: 'MultipleChoice',
    difficulty: 'Medium',
    options: [
      { text: '10', image: undefined },
      { text: '5', image: undefined },
      { text: '50', image: undefined },
      { text: '1', image: undefined }
    ],
    correctAnswer: '10',
    hints: ['5 is in the tens place, 6 is in the ones place']
  },
  {
    id: 'question-B007',
    standardId: 'standard-012',
    text: 'In 7,831, what is the value of the digit 8 compared to the value of the digit 3?',
    type: 'TypeIn',
    difficulty: 'Medium',
    correctAnswer: '10 times greater',
    hints: ['Compare the place values']
  },
  {
    id: 'question-B008',
    standardId: 'standard-012',
    text: 'In the number 9,524, the value of the digit 5 is how many times the value of the digit 2?',
    type: 'MultipleChoice',
    difficulty: 'Medium',
    options: [
      { text: '10 times', image: undefined },
      { text: '100 times', image: undefined },
      { text: '1000 times', image: undefined },
      { text: '2.5 times', image: undefined }
    ],
    correctAnswer: '100 times',
    hints: ['5 is in the hundreds place and 2 is in the ones place']
  },
  {
    id: 'question-B009',
    standardId: 'standard-012',
    text: 'In the number 6,472, the value of the digit 4 is how many times less than the value of the digit 6?',
    type: 'MultipleChoice',
    difficulty: 'Medium',
    options: [
      { text: '10 times', image: undefined },
      { text: '100 times', image: undefined },
      { text: '1000 times', image: undefined },
      { text: '1.5 times', image: undefined }
    ],
    correctAnswer: '10 times',
    hints: ['Compare the place values of 4 and 6']
  },
  
  // Questions for standard-012 (5.NBT.A.1) - HARD
  {
    id: 'question-B010',
    standardId: 'standard-012',
    text: 'In the number 8,357.42, what is the relationship between the value of the digit 7 and the digit 4?',
    type: 'MultipleChoice',
    difficulty: 'Hard',
    options: [
      { text: '7 is 10 times greater than 4', image: undefined },
      { text: '7 is 100 times greater than 4', image: undefined },
      { text: '7 is 1000 times greater than 4', image: undefined },
      { text: '7 is 10000 times greater than 4', image: undefined }
    ],
    correctAnswer: '1000 times greater than 4',
    hints: ['Consider the decimal place values']
  },
  {
    id: 'question-B011',
    standardId: 'standard-012',
    text: 'In 5,243.9, how many times greater is the value of 4 than the value of 9?',
    type: 'TypeIn',
    difficulty: 'Hard',
    correctAnswer: '10',
    hints: ['4 is in the ones place and 9 is in the tenths place']
  },
  {
    id: 'question-B012',
    standardId: 'standard-012',
    text: 'In the number 72,594, explain the relationship between the digits 7 and 9 in terms of place value.',
    type: 'TypeIn',
    difficulty: 'Hard',
    correctAnswer: '7 is 1000 times greater than 9',
    hints: ['7 is in the ten thousands place and 9 is in the tens place']
  },
  {
    id: 'question-B013',
    standardId: 'standard-012',
    text: 'In 429.356, what is the relationship between the digits 9 and 5?',
    type: 'MultipleChoice',
    difficulty: 'Hard',
    options: [
      { text: '9 is 10 times greater than 5', image: undefined },
      { text: '9 is 100 times greater than 5', image: undefined },
      { text: '9 is 1000 times greater than 5', image: undefined },
      { text: '9 is 10000 times greater than 5', image: undefined }
    ],
    correctAnswer: '9 is 100 times greater than 5',
    hints: ['9 is in the ones place and 5 is in the hundredths place']
  },
  {
    id: 'question-B014',
    standardId: 'standard-012',
    text: 'A digit in one place represents 1/10 of what it represents in the place to its left. Using this rule, explain the relationship between 6 and 6 in the number 6,324.6',
    type: 'TypeIn',
    difficulty: 'Hard',
    correctAnswer: 'The first 6 is 10000 times greater than the second 6',
    hints: ['Count the number of places between the two 6s']
  },
  
  // Questions for standard-014 (6.RP.A.1) - Ratio concepts
  {
    id: 'question-022',
    standardId: 'standard-014',
    text: 'If a recipe calls for 2 cups of flour for every 3 cups of milk, what is the ratio of flour to milk?',
    type: 'MultipleChoice',
    difficulty: 'Easy',
    options: [
      { text: '2:3', image: undefined },
      { text: '3:2', image: undefined },
      { text: '2/3', image: undefined },
      { text: '3/2', image: undefined }
    ],
    correctAnswer: '2:3',
    hints: ['A ratio compares two quantities']
  },
  {
    id: 'question-023',
    standardId: 'standard-014',
    text: 'Write the ratio of boys to girls if there are 15 boys and 12 girls in a class.',
    type: 'TypeIn',
    difficulty: 'Medium',
    correctAnswer: '15:12',
    hints: ['A ratio compares the first quantity to the second quantity']
  },
  {
    id: 'question-024',
    standardId: 'standard-014',
    text: 'A fruit basket has 8 apples, 6 oranges, and 4 bananas. What is the ratio of apples to total pieces of fruit?',
    type: 'MultipleChoice',
    difficulty: 'Hard',
    options: [
      { text: '8:18', image: undefined },
      { text: '8:10', image: undefined },
      { text: '4:9', image: undefined },
      { text: '2:3', image: undefined }
    ],
    correctAnswer: '8:18',
    hints: ['First find the total number of fruits by adding 8 + 6 + 4']
  },
  
  // Add more questions for other standards
  {
    id: 'question-025',
    standardId: 'standard-008',
    text: 'What does 3 × 4 mean?',
    type: 'MultipleChoice',
    difficulty: 'Easy',
    options: [
      { text: '3 + 4', image: undefined },
      { text: '3 groups of 4', image: undefined },
      { text: '4 groups of 3', image: undefined },
      { text: '3 - 4', image: undefined }
    ],
    correctAnswer: '3 groups of 4',
    hints: ['Multiplication represents repeated addition or groups']
  },
  {
    id: 'question-026',
    standardId: 'standard-009',
    text: 'What does 12 ÷ 3 mean?',
    type: 'MultipleChoice',
    difficulty: 'Easy',
    options: [
      { text: '12 + 3', image: undefined },
      { text: '12 groups of 3', image: undefined },
      { text: 'How many 3s make 12', image: undefined },
      { text: '3 - 12', image: undefined }
    ],
    correctAnswer: 'How many 3s make 12',
    hints: ['Division is finding how many equal groups you can make']
  },
  {
    id: 'question-027',
    standardId: 'standard-007',
    text: 'In the number 425, what does the 2 represent?',
    type: 'MultipleChoice',
    difficulty: 'Easy',
    options: [
      { text: '2', image: undefined },
      { text: '20', image: undefined },
      { text: '200', image: undefined },
      { text: '2000', image: undefined }
    ],
    correctAnswer: '20',
    hints: ['Think about the place value of each digit']
  },
  {
    id: 'question-028',
    standardId: 'standard-011',
    text: 'Which fraction is greater: 2/3 or 3/5?',
    type: 'MultipleChoice',
    difficulty: 'Medium',
    options: [
      { text: '2/3', image: undefined },
      { text: '3/5', image: undefined },
      { text: 'They are equal', image: undefined },
      { text: 'Cannot be determined', image: undefined }
    ],
    correctAnswer: '2/3',
    hints: ['Find a common denominator to compare']
  },
  {
    id: 'question-029',
    standardId: 'standard-013',
    text: 'What is 3.6 × 10?',
    type: 'TypeIn',
    difficulty: 'Easy',
    correctAnswer: '36',
    hints: ['When multiplying by 10, move the decimal point one place to the right']
  },
  {
    id: 'question-030',
    standardId: 'standard-015',
    text: 'What does a unit rate of 24 miles per 3 hours mean?',
    type: 'MultipleChoice',
    difficulty: 'Medium',
    options: [
      { text: '8 miles per hour' },
      { text: '72 miles per hour' },
      { text: '24 miles in 3 hours' },
      { text: '3 hours for 24 miles' }
    ],
    correctAnswer: '8 miles per hour',
    hints: ['Divide 24 miles by 3 hours to find the miles per one hour']
  },
  {
    id: 'question-031',
    standardId: 'standard-015',
    text: 'To convert a fraction to a decimal, you divide the [blank] by the [blank].',
    type: 'FillBlank',
    difficulty: 'Medium',
    correctAnswer: 'numerator,denominator',
    hints: ['The top number in a fraction is called the numerator, and the bottom number is called the denominator.']
  }
];